(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fs-header"]) return;
  try {
    
/* ─────────────────────────────────────────────────────────────────────────
   THE "REAL KITCHENS" TILES PLAY, SILENTLY, AND OPEN LARGE WITH SOUND.

   ⚠️ AN INTERSECTION OBSERVER IS NO USE HERE, and that is the one thing that
   makes this different from the community wall and the product page, which both
   use one. Those rows are on the page; this rail is inside a drawer that is
   `hidden` until somebody taps the burger, and a hidden element never
   intersects anything. So the drawer's own [hidden] attribute is the signal —
   watched with a MutationObserver, because the attribute is the source of truth
   the rest of this file already agrees on, and reading it means never having to
   care WHICH script opened the drawer.

   Everything else is the discipline the rest of the theme already keeps:
   `preload="none"` so nothing downloads for a shopper who never opens the menu,
   the file attached on first open only, and every clip paused the moment the
   drawer shuts — a video still running behind a closed drawer is a phone
   getting warm in somebody's pocket.
   ───────────────────────────────────────────────────────────────────────── */
(function () {
  var drawer = document.querySelector('[data-fs-mobilemenu]');
  var rail = document.querySelector('.fs-head__ugcrail');
  if (!drawer || !rail) return;

  var clips = Array.prototype.slice.call(rail.querySelectorAll('[data-fs-headugc-video]'));
  if (!clips.length) return;

  /* Reduced motion means the posters stay still. The tiles keep working — a
     tap still opens the clip, which is a thing the shopper asked for. */
  var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function play(v) {
    if (still) return;
    if (!v.dataset.loaded) { v.src = v.getAttribute('data-src'); v.dataset.loaded = '1'; }
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }
  function stop(v) { if (!v.paused) v.pause(); }
  function playAll() { clips.forEach(play); }
  function stopAll() { clips.forEach(stop); }

  var open = !drawer.hasAttribute('hidden');
  if (open) playAll();

  new MutationObserver(function () {
    var now = !drawer.hasAttribute('hidden');
    if (now === open) return;
    open = now;
    now ? playAll() : stopAll();
  }).observe(drawer, { attributes: true, attributeFilter: ['hidden'] });

  /* A backgrounded tab keeps decoding video on some browsers. */
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) stopAll();
  });

  /* ── the clip, large ──
     The <video> is BUILT ON OPEN AND DESTROYED ON CLOSE. One parked in a closed
     dialog goes on buffering and holds the file in memory for somebody who
     watched it once.

     The hooks are this section's own — `data-fs-headugc-*`. The product page
     has the same dialog under `data-fs-ugcpop`, and on a product page BOTH are
     in the document; a shared hook would have let its script grab this dialog,
     because this one is above it in the DOM. */
  var pop = document.querySelector('[data-fs-headugcpop]');
  var stage = pop && pop.querySelector('[data-fs-headugcstage]');
  if (!pop || !stage || typeof pop.showModal !== 'function') return;

  function shut() {
    /* Pause before emptying: a detached element that is still playing goes on
       downloading in some browsers. */
    var v = stage.querySelector('video');
    if (v) { v.pause(); v.removeAttribute('src'); v.load(); }
    stage.textContent = '';
    if (pop.open) pop.close();
    if (!drawer.hasAttribute('hidden')) playAll();
  }

  document.addEventListener('click', function (e) {
    var hit = e.target.closest && e.target.closest('[data-fs-headugc-open]');
    if (hit && rail.contains(hit)) {
      e.preventDefault();
      stopAll();
      stage.textContent = '';
      var v = document.createElement('video');
      v.src = hit.getAttribute('data-src');
      v.controls = true; v.loop = true; v.playsInline = true; v.autoplay = true;
      stage.appendChild(v);
      pop.showModal();
      /* Sound is what a tap on a silent clip is asking for, and the tap is the
         gesture that permits it. If the browser refuses anyway, fall back to
         muted rather than showing a frozen frame. */
      var pl = v.play();
      if (pl && pl.catch) pl.catch(function () { v.muted = true; v.play().catch(function () {}); });
      return;
    }
    if (e.target.closest && e.target.closest('[data-fs-headugcclose]')) { shut(); return; }
    if (e.target === pop) shut();
  });

  /* Escape fires close on the element itself, which bypasses shut(). */
  pop.addEventListener('close', function () { if (stage.firstChild) shut(); });
})();

/* Choosing a language or a country submits its form. Without this the shopper
   picks and nothing happens — there is no visible Update button, on purpose:
   a phone's own picker closes on selection and a second tap to confirm is a
   step nobody expects. With JavaScript off the select is still a real form
   control inside a real form; it simply needs the Enter key. */
document.addEventListener('change', function (e) {
  var sel = e.target.closest ? e.target.closest('[data-fs-locale-submit]') : null;
  if (sel && sel.form) sel.form.submit();
});

/* The burger only. Everything else in this header is a link or CSS hover, so
   it works with JavaScript switched off. */
(function () {
  var menu = document.getElementById('fs-mobilemenu');
  var scrim = document.querySelector('[data-fs-scrim]');
  if (!menu) return;

  function setOpen(open) {
    /* [hidden] stays the source of truth — the tuck-away script and the CSS
       both read it. The class is only what animates. */
    if (open) {
      menu.removeAttribute('hidden');
      if (scrim) scrim.removeAttribute('hidden');
      /* One frame between "in the document" and "slide in", or the browser
         has nothing to transition FROM and the drawer simply appears. */
      requestAnimationFrame(function () {
        menu.classList.add('is-open');
        if (scrim) scrim.classList.add('is-open');
      });
      document.body.classList.add('fs-noscroll');
    } else {
      menu.classList.remove('is-open');
      if (scrim) scrim.classList.remove('is-open');
      document.body.classList.remove('fs-noscroll');
      /* Wait out the slide before hiding, or it vanishes instead of leaving. */
      window.setTimeout(function () {
        if (!menu.classList.contains('is-open')) {
          menu.setAttribute('hidden', '');
          if (scrim) scrim.setAttribute('hidden', '');
        }
      }, 280);
    }
    document.querySelectorAll('[data-fs-burger]').forEach(function (b) {
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    var burger = document.querySelector('.fs-head__burger');
    if (burger) burger.textContent = open ? '\u00d7' : '\u2630';
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-fs-scrim]')) { setOpen(false); return; }
    var burger = e.target.closest('[data-fs-burger]');
    if (!burger) {
      /* Tapping a link inside the drawer navigates; the scroll lock must not
         survive that on a browser that restores the page from cache. */
      if (menu.contains(e.target) && e.target.closest('a')) setOpen(false);
      return;
    }
    setOpen(menu.hasAttribute('hidden'));
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !menu.hasAttribute('hidden')) setOpen(false);
  });

  /* Rotating to landscape can cross the breakpoint with the drawer open,
     which would leave the desktop page scroll-locked. */
  window.addEventListener('resize', function () {
    if (window.innerWidth >= 820 && !menu.hasAttribute('hidden')) setOpen(false);
  });
})();

/* ─────────────────────────────────────────────────────────────────────────
   THE HEADER TUCKS AWAY WHILE YOU SCROLL DOWN, AND COMES BACK WHEN YOU STOP
   OR TURN AROUND.  User directive 2026-08-27: "stick on pause and scroll up".

   It hides ONLY while the reader is actively moving down the page. Scrolling
   up brings it straight back; so does simply stopping, after a short pause.
   The pause is what makes it feel like a shelf rather than a trapdoor — you
   stop to read something and the navigation is there.

   Four things it deliberately will NOT do:
   · hide near the top of the page, where there is nothing to gain
   · hide while the mega menu or the mobile menu is open — the panel would go
     with it and the click would appear to do nothing
   · hide while anything inside the header has keyboard focus, which would
     tab a sighted keyboard user straight off the screen
   · move at all for a reader who has asked for reduced motion

   Everything is one class on one element. With this script absent the header
   is exactly the sticky bar it was before.
   ───────────────────────────────────────────────────────────────────────── */
(function () {
  var head = document.querySelector('.fs-head');
  if (!head) return;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var lastY = window.pageYOffset || 0;
  var idle = null;
  var ticking = false;

  /* Below this the header always shows. It is the header's own height, so the
     bar is never half-tucked at the very top of a short page. */
  function floor() { return Math.max(head.offsetHeight, 64); }

  function pinned() {
    if (reduce) return true;
    if (head.contains(document.activeElement)) return true;
    var menu = document.getElementById('fs-mobilemenu');
    if (menu && !menu.hasAttribute('hidden')) return true;
    /* :hover covers the mega menu, which opens on hover and focus-within. */
    if (head.matches(':hover') || head.querySelector(':focus-within')) return true;
    return false;
  }

  function show() { head.classList.remove('fs-head--tucked'); }
  function tuck() { if (!pinned()) head.classList.add('fs-head--tucked'); }

  function onScroll() {
    var y = window.pageYOffset || 0;
    var down = y > lastY;
    /* A couple of pixels of jitter — a trackpad, or the address bar resizing on
       a phone — must not flip it. */
    if (Math.abs(y - lastY) > 4) {
      if (y <= floor() || !down) show();
      else tuck();
      lastY = y;
    }
    clearTimeout(idle);
    idle = setTimeout(show, 220);   /* "on pause" */
    ticking = false;
  }

  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(onScroll);
  }, { passive: true });

  /* Opening either menu, or tabbing in, brings it back immediately. */
  head.addEventListener('focusin', show);
  head.addEventListener('mouseenter', show);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fs-story-cinema"] && !Shopify.designMode) return;
  try {
    
/* ───────────────────────────────────────────────────────────────────────────
   The line-up, driven by clicks instead of by scroll. User directive 2026-08-27.

   Two levels, and they are not the same kind of switch:
     · a line TAB swaps the whole group — the photographs, the chips, the copy
       and the ladder all change together, and the choice resets to the first
       model of that line
     · a model CHIP, or a row in the price ladder, moves the choice WITHIN the
       group it belongs to

   Everything is class + hidden attribute. No inline styles, so nothing here can
   leave the section in a state a stylesheet cannot describe.

   The listener is delegated from the section rather than bound per button,
   because Shopify's theme editor re-renders a section wholesale when a setting
   changes and per-button listeners would be lost with the old markup.
   ─────────────────────────────────────────────────────────────────────────── */
(function () {
  function each(root, sel, fn) { Array.prototype.forEach.call(root.querySelectorAll(sel), fn); }

  function setModel(root, group, i) {
    ['.fs-cin__shots', '.fs-cin__stack'].forEach(function (wrap) {
      each(root, wrap + '[data-fs-group="' + group + '"] [data-fs-i]', function (el) {
        el.classList.toggle('is-active', el.getAttribute('data-fs-i') === String(i));
      });
    });
    ['.fs-cin__models', '.fs-cin__rail'].forEach(function (wrap) {
      each(root, wrap + '[data-fs-group="' + group + '"] [data-fs-i]', function (el) {
        var on = el.getAttribute('data-fs-i') === String(i);
        el.classList.toggle('is-active', on);
        el.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    });
  }

  function setGroup(root, group) {
    each(root, '[data-fs-group]', function (el) {
      if (el.getAttribute('data-fs-group') === String(group)) el.removeAttribute('hidden');
      else el.setAttribute('hidden', '');
    });
    each(root, '[data-fs-tab]', function (b) {
      var on = b.getAttribute('data-fs-tab') === String(group);
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    /* A line you have just switched to shows its first model, never whichever
       index happened to be chosen on the other line. */
    setModel(root, group, 0);
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-fs-tab],[data-fs-i]');
    if (!t) return;
    var root = t.closest('[data-fs-lineup]');
    if (!root) return;

    var tab = t.getAttribute('data-fs-tab');
    if (tab) { setGroup(root, tab); return; }

    /* A chip or a ladder row: whose group is it in? */
    var wrap = t.closest('[data-fs-group]');
    if (!wrap) return;
    setModel(root, wrap.getAttribute('data-fs-group'), t.getAttribute('data-fs-i'));
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fs-support-finder"] && !Shopify.designMode) return;
  try {
    
/* ───────────────────────────────────────────────────────────────────────────
   Two steps, then remembered.

   step 1  a line tab shows one group of families; clicking a family opens
   step 2  its products; clicking one records it and collapses the band to the
           chosen-model banner. "Pick it once and this page stays yours" is the
           design file's promise, so the choice goes to localStorage and the
           banner is what an owner sees on every later visit.

   The banner is filled from data-* on the card that was clicked. There is
   deliberately no second copy of the catalog in here to drift out of step —
   if the product changes, the card changes, and so does what is stored.

   Storage is best-effort: private browsing throws on localStorage, so every
   access is wrapped. Failing to remember is not a reason to break the picker.
   ─────────────────────────────────────────────────────────────────────────── */
(function () {
  var root = document.querySelector('[data-fs-find]');
  if (!root) return;

  var KEY = root.getAttribute('data-storage-key') || 'fs-my-model';
  var panel = root.querySelector('[data-fs-panel]');
  var chosen = root.querySelector('[data-fs-chosen]');

  function each(sel, fn) { Array.prototype.forEach.call(root.querySelectorAll(sel), fn); }
  function show(el) { if (el) el.removeAttribute('hidden'); }
  function hide(el) { if (el) el.setAttribute('hidden', ''); }

  function store(v) { try { v ? localStorage.setItem(KEY, JSON.stringify(v)) : localStorage.removeItem(KEY); } catch (e) {} }
  function recall() { try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { return null; } }

  /* TELL THE REST OF THE PAGE. The request band's heading and its hidden
     Product field, and the warranty band's customer tag, all read this same
     storage key -- and they read it when the page loads. An owner who changes
     their mind never reloads, so without this the support email would confidently
     name the model they just replaced, which is worse than naming none.
     `new CustomEvent` is not a constructor on very old browsers; the fallback
     keeps the picker working there, minus the live update. */
  function announce() {
    var ev;
    try { ev = new CustomEvent('fs:model-change'); }
    catch (e) { ev = document.createEvent('Event'); ev.initEvent('fs:model-change', true, false); }
    document.dispatchEvent(ev);
  }

  function paintChosen(m) {
    if (!m || !m.name) { hide(chosen); show(panel); return; }
    var shot = chosen.querySelector('[data-fs-chosen-shot]');
    if (shot) shot.style.backgroundImage = m.shot ? 'url(' + m.shot + ')' : '';
    chosen.querySelector('[data-fs-chosen-name]').textContent = m.name;
    chosen.querySelector('[data-fs-chosen-spec]').textContent = m.spec || '';
    var link = chosen.querySelector('[data-fs-chosen-link]');
    if (link) { if (m.url) { link.href = m.url; show(link); } else hide(link); }
    show(chosen); hide(panel);
  }

  function step(n) {
    each('[data-fs-step]', function (s) {
      s.getAttribute('data-fs-step') === String(n) ? show(s) : hide(s);
    });
  }

  function openFamily(handle, label) {
    each('[data-fs-fampanel]', function (p) {
      p.getAttribute('data-fs-fampanel') === handle ? show(p) : hide(p);
    });
    var lbl = root.querySelector('[data-fs-famlabel]');
    if (lbl) lbl.textContent = label || '';
    step(2);
  }

  root.addEventListener('click', function (e) {
    var t = e.target.closest(
      '[data-fs-ftab],[data-fs-family],[data-fs-model],[data-fs-back],[data-fs-reset]');
    if (!t || !root.contains(t)) return;

    if (t.hasAttribute('data-fs-reset')) { store(null); paintChosen(null); announce(); step(1); return; }
    if (t.hasAttribute('data-fs-back'))  { step(1); return; }

    var tab = t.getAttribute('data-fs-ftab');
    if (tab) {
      each('[data-fs-fgroup]', function (g) {
        g.getAttribute('data-fs-fgroup') === tab ? show(g) : hide(g);
      });
      each('[data-fs-ftab]', function (b) {
        var on = b.getAttribute('data-fs-ftab') === tab;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      return;
    }

    var fam = t.getAttribute('data-fs-family');
    if (fam) {
      var nameEl = t.querySelector('.fs-find2__famname');
      openFamily(fam, nameEl ? nameEl.textContent.trim() : '');
      return;
    }

    if (t.hasAttribute('data-fs-model')) {
      var m = {
        name: t.getAttribute('data-name'),
        url:  t.getAttribute('data-url'),
        spec: t.getAttribute('data-spec'),
        shot: t.getAttribute('data-shot'),
        /* Read by the request band, never displayed. A pick stored before this
           field existed simply has no `sku`, and every reader treats an absent
           SKU the same as a blank one. */
        sku:  t.getAttribute('data-sku')
      };
      store(m); paintChosen(m); announce();
    }
  });

  paintChosen(recall());
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fs-support-hub"] && !Shopify.designMode) return;
  try {
    
/* The five doors. Exactly one panel is in the document at a time — that is the
   design file's behaviour and the reason this page reads as one topic rather
   than a wall. The jump chips below are NOT doors; they are ordinary anchors to
   sections that are always present.

   With JavaScript off the first panel is the one Liquid rendered visible and the
   rest stay hidden. That is a lesser page, not a broken one, and every topic is
   still reachable — the jump chips and the anchors all work. */
(function () {
  var root = document.querySelector('[data-fs-sup]');
  if (!root) return;

  root.addEventListener('click', function (e) {
    var door = e.target.closest('[data-fs-door]');
    if (door && root.contains(door)) {
      var key = door.getAttribute('data-fs-door');
      Array.prototype.forEach.call(root.querySelectorAll('[data-fs-panel]'), function (p) {
        if (p.getAttribute('data-fs-panel') === key) p.removeAttribute('hidden');
        else p.setAttribute('hidden', '');
      });
      Array.prototype.forEach.call(root.querySelectorAll('[data-fs-door]'), function (b) {
        var on = b === door;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      return;
    }

    /* The blade rail's arrows. It is a real scroll container, so a touch device
       swipes it and these are an addition for a mouse, never the only way. */
    var arrow = e.target.closest('[data-fs-rail]');
    if (arrow && root.contains(arrow)) {
      var track = arrow.closest('[data-fs-panel]').querySelector('[data-fs-railtrack]');
      if (!track) return;
      var card = track.querySelector('.fs-sup__blade');
      var step = card ? card.getBoundingClientRect().width + 14 : 240;
      track.scrollBy({ left: step * Number(arrow.getAttribute('data-fs-rail')), behavior: 'smooth' });
    }
  });

  /* ── a blade opens its recipes ──
     The design file's pickBlade: the chip goes dark, the panel below fills with
     that blade's recipes, and Close puts it away. One panel, filled from JSON. */
  (function () {
    var data = {};
    var tag = root.querySelector('[data-fs-bladedata]');
    try { data = JSON.parse(tag.textContent); } catch (e) { return; }
    var panel = root.querySelector('[data-fs-bladeresult]');
    if (!panel) return;
    var lead = panel.querySelector('[data-fs-bladelead]');
    var none = panel.querySelector('[data-fs-bladenone]');
    var has  = panel.querySelector('[data-fs-bladehasrecipes]');
    var grid = panel.querySelector('[data-fs-bladerecipegrid]');
    var open = null;

    function paint(id) {
      var b = data[id];
      if (!b) return;
      lead.textContent = b.name;
      grid.textContent = '';
      var list = b.recipes || [];
      list.forEach(function (r) {
        /* No url means a typed recipe with no page yet — a link to nowhere
           is worse than plain text, so it renders as a card, not an anchor. */
        var a = document.createElement(r.url ? 'a' : 'div');
        a.className = 'fs-sup__bladerecipe';
        if (r.url) a.href = r.url;
        var t = document.createElement('span');
        t.className = 'fs-sup__bladerecipet';
        t.textContent = r.title;
        a.appendChild(t);
        /* meta is empty until custom.meal / custom.time are filled — an empty
           line would print as a stray gap, so it is only added when real. */
        if (r.meta) {
          var m = document.createElement('span');
          m.className = 'fs-sup__bladerecipem';
          m.textContent = r.meta;
          a.appendChild(m);
        }
        grid.appendChild(a);
      });
      list.length ? (has.removeAttribute('hidden'), none.setAttribute('hidden', ''))
                  : (has.setAttribute('hidden', ''), none.removeAttribute('hidden'));
      panel.removeAttribute('hidden');
    }

    function mark(id) {
      Array.prototype.forEach.call(root.querySelectorAll('[data-blade-chip]'), function (c) {
        var on = c.getAttribute('data-blade-chip') === id;
        c.classList.toggle('is-picked', on);
        c.setAttribute('aria-expanded', on ? 'true' : 'false');
      });
    }

    function shut() { open = null; mark(null); panel.setAttribute('hidden', ''); }

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-fs-bladeclear]')) { shut(); return; }
      var chip = e.target.closest('[data-blade-chip]');
      if (!chip || !root.contains(chip)) return;
      var id = chip.getAttribute('data-blade-chip');
      /* Clicking the open blade again closes it — the file's toggle. */
      if (id === open) { shut(); return; }
      open = id; mark(id); paint(id);
    });
  })();

  /* The right-edge fade, as in the design file: it says "the rail continues",
     so it has to stop saying it once there is nothing left to scroll to. A
     fade parked over the last card reads as a rendering fault, not a cue. */
  Array.prototype.forEach.call(root.querySelectorAll('[data-fs-railtrack]'), function (track) {
    var fade = track.parentNode.querySelector('.fs-sup__railfade');
    if (!fade) return;
    function sync() {
      var end = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      fade.style.opacity = end ? '0' : '1';
    }
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fs-support-request"] && !Shopify.designMode) return;
  try {
    
/* Attach the model the owner already picked to the message they are about to
   send. Read-only against the finder's storage — this band never writes it.

   ⚠️ IT RE-READS ON EVERY CHANGE, AND THAT IS THE WHOLE POINT. The finder is on
   this same page and picking a second model never reloads it, so a script that
   ran once at load left this heading — and the hidden Product field — naming
   the model that had just been replaced. An email that names the wrong chopper
   is worse than one that names none: nobody looks twice at a stated fact.
   fs-support-finder fires `fs:model-change` on every pick and on every reset,
   and `storage` covers the same shop open in a second tab. Storage is re-read
   each time rather than trusting anything carried on the event, so there is
   still exactly one source of truth. */
(function () {
  function recall(key) {
    /* Private browsing throws on localStorage. Failing to remember is not a
       reason to break a support form. */
    try { return JSON.parse(localStorage.getItem(key) || 'null'); } catch (e) { return null; }
  }

  /* "4-in-1 / White — XL Chopper and Slicer with Pull-Out Tray": the variant
     first, because that is the thing on their counter, then the page it lives
     on. Both are already strings the finder put there; nothing is looked up. */
  function label(m) {
    if (!m || !m.name) return '';
    return m.spec ? (m.name + ' — ' + m.spec) : m.name;
  }

  function paint(root, m) {
    var text = label(m);

    var product = root.querySelector('[data-fs-req-product]');
    if (product) { product.value = text; product.disabled = !text; }

    var sku = root.querySelector('[data-fs-req-sku]');
    if (sku) {
      var code = (m && m.sku) || '';
      sku.value = code;
      sku.disabled = !code;
    }

    var url = root.querySelector('[data-fs-req-url]');
    if (url) {
      var href = (m && m.url) || '';
      /* An absolute address, so the email is one click for whoever reads it. */
      if (href && href.indexOf('http') !== 0) href = location.origin + href;
      url.value = href;
      url.disabled = !href;
    }

    var generic = root.querySelector('[data-fs-req-generic]');
    var titled = root.querySelector('[data-fs-req-titled]');
    var name = root.querySelector('[data-fs-req-model]');
    if (!generic || !titled || !name) return;

    if (text) {
      name.textContent = text;
      generic.setAttribute('hidden', '');
      titled.removeAttribute('hidden');
    } else {
      /* Back to the generic wording, so a cleared pick does not leave a
         heading asking about a model nobody selected. */
      name.textContent = '';
      titled.setAttribute('hidden', '');
      generic.removeAttribute('hidden');
    }
  }

  function refresh() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-fs-req]'), function (root) {
      paint(root, recall(root.getAttribute('data-storage-key') || 'fs-my-model'));
    });
  }

  refresh();
  document.addEventListener('fs:model-change', refresh);
  window.addEventListener('storage', refresh);
  /* The theme editor swaps a section in without a page load. */
  document.addEventListener('shopify:section:load', refresh);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fs-welcome-offer"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('[data-fs-offer]');
  if (!root) return;

  var KEY = root.getAttribute('data-key') || 'fs-welcome-offer';
  var seen;
  /* Private browsing throws on localStorage. A popup that cannot remember
     is better than a page that throws. */
  try { seen = localStorage.getItem(KEY); } catch (e) { seen = null; }
  if (seen) return;

  var card = root.querySelector('.fs-offer__card');
  var form = root.querySelector('[data-fs-offer-form]');
  var won = root.querySelector('[data-fs-offer-won]');
  var err = root.querySelector('[data-fs-offer-error]');
  var codeBtn = root.querySelector('[data-fs-offer-code]');

  function remember(v) { try { localStorage.setItem(KEY, v); } catch (e) {} }

  function open() {
    root.removeAttribute('hidden');
    requestAnimationFrame(function () { root.classList.add('is-open'); });
    document.body.classList.add('fs-noscroll');
    var f = root.querySelector('.fs-offer__input');
    if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 320);
  }

  function close() {
    root.classList.remove('is-open');
    document.body.classList.remove('fs-noscroll');
    /* Dismissing counts: asking again on the next page is nagging. */
    remember('dismissed');
    setTimeout(function () { root.setAttribute('hidden', ''); }, 300);
  }

  var delay = (parseFloat(root.getAttribute('data-delay')) || 6) * 1000;
  var timer = setTimeout(open, delay);

  /* Leaving for the tab bar is the other moment worth asking. Pointer only:
     a phone has no cursor to leave the viewport, and the timer covers it. */
  document.addEventListener('mouseout', function (e) {
    if (e.clientY <= 0 && !root.classList.contains('is-open') && root.hasAttribute('hidden')) {
      clearTimeout(timer); open();
    }
  });

  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-fs-offer-close]')) close();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !root.hasAttribute('hidden')) close();
  });

  if (codeBtn) {
    codeBtn.addEventListener('click', function () {
      var hint = codeBtn.querySelector('[data-fs-offer-codehint]');
      var code = codeBtn.getAttribute('data-code') || '';
      var done = function () { if (hint) { hint.textContent = 'Copied'; } };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done, function () {});
      }
    });
  }

  if (!form) return;
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var input = form.querySelector('.fs-offer__input');
    var go = form.querySelector('.fs-offer__go');
    var email = (input && input.value || '').trim();
    err.hidden = true;

    /* Deliberately loose: the server decides what a valid address is, and a
       regex here only ever turns real addresses away. */
    if (!email || email.indexOf('@') < 1 || email.indexOf('.') < 0) {
      err.textContent = 'Enter an email address so we can send the code.';
      err.hidden = false;
      if (input) input.focus();
      return;
    }

    go.disabled = true;
    var body = new FormData();
    body.append('form_type', 'customer');
    body.append('utf8', '✓');
    body.append('contact[email]', email);
    body.append('contact[tags]', 'newsletter,welcome-offer');

    /* Posted with fetch so the page does not reload and take the popup with
       it. Shopify answers 200 with the page HTML either way, so the reveal
       does not hang on parsing a response it cannot trust. */
    fetch('/contact', { method: 'POST', body: body, headers: { 'Accept': 'text/html' } })
      .catch(function () {})
      .then(function () {
        form.hidden = true;
        won.hidden = false;
        remember('subscribed');
        go.disabled = false;
      });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
